import { render } from "./temp.vue?vue&type=template&id=417b283d&scoped=true"
const script = {}

import "./temp.vue?vue&type=style&index=0&id=417b283d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-417b283d"

export default script